import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import clsx from "clsx";

import { Button } from "@mui/material";

import { CAMPAIGN, CREATE_PAGE } from "../../../../configurations/appConstants";
import { selectIsLoading } from "../../../../business/selectors/applicationSelectors";
import { selectCurrentCampaign } from "../../../../business/models/Campaign/campaignSelectors";
import { closePlanExtensionFormPage } from "../../../../business/actions/campaignDashboardActions";

import {
  cancelPlanExtension,
  updatePlanExtension,
  createPlanExtension
} from "../../../../business/models/PlanExtension/planExtensionActions";

import { selectIsPlanExtensionNewFromUpdate } from "../../../../business/models/PlanExtension/planExtensionSelectors";

import { generateUrlPath } from "../../../../business/models/common/utils/clientUtils";
import { classes, Grid } from "../styles/planExtensionEditActions";

const PlanExtensionEditActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { agency } = useParams();

  const isLoading = useSelector(selectIsLoading);
  const isPlanExtensionNewFromUpdate = useSelector(
    selectIsPlanExtensionNewFromUpdate
  );
  const campaignId = useSelector(selectCurrentCampaign);

  const handleCancel = () => {
    dispatch(cancelPlanExtension());
    dispatch(closePlanExtensionFormPage()).then(() =>
      navigate(`/${agency}/${CREATE_PAGE}/${CAMPAIGN}/${campaignId}`)
    );
  };

  const handleSaveNew = () => {
    dispatch(createPlanExtension()).then(planId => {
      if (planId) {
        dispatch(closePlanExtensionFormPage()).then(() =>
          navigate(
            `/${agency}/${CREATE_PAGE}${generateUrlPath(campaignId, planId)}`
          )
        );
      }
    });
  };

  const handleSave = () => {
    if (isPlanExtensionNewFromUpdate) {
      handleSaveNew();
    } else {
      dispatch(updatePlanExtension()).then(planId => {
        if (planId) {
          dispatch(closePlanExtensionFormPage()).then(() =>
            navigate(
              `/${agency}/${CREATE_PAGE}${generateUrlPath(campaignId, planId)}`
            )
          );
        }
      });
    }
  };

  return (
    <Grid container justifyContent="space-between">
      <Grid item>
        <Button
          id="cancel_plan_extension"
          name="cancel_plan_extension"
          className={classes.cancelButton}
          onClick={handleCancel}
          disabled={isLoading}
        >
          CANCEL
        </Button>
      </Grid>
      <Grid item>
        <Grid container justifyContent="space-around" spacing={2}>
          <Grid item>
            <Button
              id="save_plan_extension"
              name="save_plan_extension"
              variant="contained"
              className={clsx(classes.saveButton, classes.markedButton)}
              disabled={isLoading}
              onClick={handleSave}
            >
              SAVE CHANGES
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PlanExtensionEditActions;
